module.exports = __webpack_public_path__ + "img/consultation-fee-desktop-ru.2593a652.jpg";